// INTERIM: search and full-profile return the same payload, so we infer intent
// from the user's message until the BE tags full-profile responses.
import type { BlockOutput } from '../types';

const FULL_PROFILE_RE = /full\s+profiles?/i;

export const wantsFullProfiles = (text: string | undefined | null): boolean =>
  typeof text === 'string' && FULL_PROFILE_RE.test(text);

// Promote a candidate (compact list) block to the candidateProfiles carousel.
export const toCandidateProfilesBlock = (block: BlockOutput): BlockOutput => {
  if (block.type !== 'candidate') return block;
  const { summary, candidates, suggestedActions, appIds, toolCallId } =
    block.data;
  return {
    type: 'candidateProfiles',
    data: {
      intro: summary || undefined,
      candidates,
      suggestedActions,
      appIds,
      toolCallId,
    },
  };
};
